export const RUM_ACTION_ATTRIBUTE = 'data-dd-action-name';
